import z from 'zod';

import { httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';
import { filteredArraySchema } from 'app-components/utils/zodHelpers';

import { SalesTaxSchema, type SalesTaxType } from './SalesTaxesTypes';

const RemoteSalesTypeSchema = SalesTaxSchema.and(z.object({ id: z.string() }));

const GetSalesTaxesResponseSchema = z.object({
  resources: filteredArraySchema(RemoteSalesTypeSchema),
});

const PostSalesTaxesResponseSchema = z.object({
  resource: RemoteSalesTypeSchema,
  clientId: z.string().optional(),
  id: z.string(),
});
export type PostSalesTaxesResponseType = z.infer<typeof PostSalesTaxesResponseSchema>;

const PutSalesTaxesResponseSchema = z.object({
  resource: RemoteSalesTypeSchema,
  id: z.string(),
});
export type PutSalesTaxesResponseType = z.infer<typeof PutSalesTaxesResponseSchema>;

export default {
  async create(salesTax: SalesTaxType & { clientId: string }) {
    const requestUrl = `${getServiceUrl()}/businesses/sales-tax`;
    return PostSalesTaxesResponseSchema.parse((await httpClientInterface.send('POST', requestUrl, salesTax)).data);
  },
  async fetch() {
    const requestUrl = `${getServiceUrl()}/businesses/sales-tax`;
    return GetSalesTaxesResponseSchema.parse((await httpClientInterface.send('GET', requestUrl)).data).resources;
  },
  async update(salesTax: SalesTaxType & { id: string }) {
    const requestUrl = `${getServiceUrl()}/businesses/sales-tax/${salesTax.id}`;
    return PutSalesTaxesResponseSchema.parse((await httpClientInterface.send('PUT', requestUrl, salesTax)).data);
  },
  async delete(id: string) {
    const requestUrl = `${getServiceUrl()}/businesses/sales-tax/${id}`;
    await httpClientInterface.send('DELETE', requestUrl);
  },
} as const;
